export const selectGeographyAnalyticsState = (state) =>
  state.geographyAnalytics || {};
export const selectGeographyData = (state) =>
  selectGeographyAnalyticsState(state).geographyData || [];
export const selectLoading = (state) =>
  selectGeographyAnalyticsState(state).loading || false;
export const selectError = (state) =>
  selectGeographyAnalyticsState(state).error;
export const selectPagination = (state) =>
  selectGeographyAnalyticsState(state).pagination || { currentPage: 1, pageSize: 10, total: 0 };